import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { API, L, fmtDateTime } from './shared';

const timeline = (r, lang) => {
  const ev = [];
  if (r.invitation?.invited_at) ev.push({ kind: 'event', at: r.invitation.invited_at, text: L(lang, 'Η διαχείριση έστειλε πρόσκληση', 'Management sent invitation') });
  ev.push({ kind: 'owner', at: r.submitted_at, text: r.description, label: L(lang, 'Ο ιδιοκτήτης υπέβαλε αίτημα', 'Owner submitted request') });
  (r.owner_replies || []).forEach((m) => ev.push(m.from === 'owner'
    ? { kind: 'owner', at: m.at, text: m.text, label: L(lang, 'Ο ιδιοκτήτης απάντησε', 'Owner replied') }
    : { kind: 'mgmt', at: m.at, text: m.text, label: `${L(lang, 'Η διαχείριση απάντησε', 'Management replied')} · ${m.by || ''}`, status: m.email_status }));
  return ev.sort((a, b) => String(a.at || '').localeCompare(String(b.at || '')));
};

const CLS = { owner: 'border-blue-500 bg-blue-50/50', mgmt: 'border-emerald-500 bg-emerald-50/40', event: 'border-zinc-300' };

export const ConversationThread = ({ r, lang, canEdit, onChange }) => {
  const [text, setText] = useState('');
  const [expect, setExpect] = useState(true);
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const res = (await axios.post(`${API}/owner-feedback/responses/${r.response_id}/reply`, { text, expect_reply: expect })).data;
      onChange(res); setText('');
      const st = res.owner_replies?.[res.owner_replies.length - 1]?.email_status || '';
      if (st === 'failed: no email address') toast.message(L(lang, 'Η απάντηση αποθηκεύτηκε (ο ιδιοκτήτης δεν έχει email)', 'Reply saved (owner has no email)'));
      else if (st.startsWith('failed')) toast.error(st); else toast.success(L(lang, 'Η απάντηση στάλθηκε στον ιδιοκτήτη', 'Reply sent to owner'));
    } catch (e) { toast.error(e.response?.data?.detail || 'Error'); } finally { setBusy(false); }
  };
  return (
    <div className="mb-4" data-testid="of-conversation">
      <div className="text-[10px] uppercase tracking-wider text-zinc-500 mb-1">{L(lang, 'Ιστορικό συνομιλίας (χρονολογικά)', 'Conversation history (chronological)')}</div>
      {timeline(r, lang).map((e, i) => (
        <div key={i} className={`text-sm border-l-2 pl-2 py-1 mb-1 ${CLS[e.kind]}`} data-testid={`of-conv-item-${i}`}>
          <div className="text-[11px] font-semibold text-zinc-600">{fmtDateTime(e.at)} – {e.label || e.text}</div>
          {e.label && <div className="whitespace-pre-wrap">{e.text}</div>}
          {e.status && <div className="text-[10px] text-zinc-400">{e.status}</div>}
        </div>))}
      {canEdit && (
        <div className="mt-2">
          <Textarea rows={3} className="rounded-none" placeholder={L(lang, 'Απάντηση προς τον ιδιοκτήτη (στέλνεται με email και προσωπικό σύνδεσμο)', 'Reply to owner (emailed with personal link)')} value={text} onChange={(e) => setText(e.target.value)} data-testid="of-reply-text" />
          <div className="flex items-center gap-3 mt-1">
            <label className="flex items-center gap-1.5 text-xs flex-1"><input type="checkbox" checked={expect} onChange={(e) => setExpect(e.target.checked)} data-testid="of-reply-expect" />{L(lang, 'Αναμένεται απάντηση από τον ιδιοκτήτη', 'Owner response expected')}</label>
            <Button className="rounded-none" disabled={!text.trim() || busy} onClick={send} data-testid="of-reply-send-btn">{L(lang, 'Αποστολή απάντησης', 'Send reply')}</Button>
          </div>
        </div>)}
    </div>
  );
};

export default ConversationThread;
